import commonZhHK from './common_zh-HK'

const cheZhHK = {
  che: {
    ...commonZhHK,
  }
}

export default cheZhHK